(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dl-interactive-rack"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dl-interactive-rack')) {
    customElements.define('dl-interactive-rack', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) { this.resize?.observe(this.stage); return; }
        this.initialized = true;
        this.items = [...this.querySelectorAll('[data-item]')];
        if (!this.items.length) return;
        this.visible = this.items;
        this.index = 0;
        this.panels = [...this.querySelectorAll('[data-panel]')];
        this.stage = this.querySelector('[data-stage]');
        this.classList.add('is-ready');
        this.querySelectorAll('[data-controls]').forEach(el => el.hidden = false);
        this.querySelectorAll('[data-filter]').forEach(button => {
          if (button.dataset.filter !== 'all' && !this.items.some(item => item.dataset.category === button.dataset.filter)) button.hidden = true;
          button.addEventListener('click', () => {
            this.stopHover();
            this.querySelectorAll('[data-filter]').forEach(el => el.setAttribute('aria-pressed', String(el === button)));
            this.visible = this.items.filter(item => button.dataset.filter === 'all' || item.dataset.category === button.dataset.filter);
            this.index = 0;
            this.render();
          });
        });
        this.querySelector('[data-prev]').addEventListener('click', () => this.move(-1));
        this.querySelector('[data-next]').addEventListener('click', () => this.move(1));
        this.items.forEach(item => {
          item.dataset.angle = '0';
          item.addEventListener('click', event => {
            if (this.suppressClick) return;
            const index = this.visible.indexOf(item);
            if (index !== this.index) { this.index = index; this.render(); }
            else if (event.detail === 0 && item.dataset.hasBack === 'true') this.turn(Number(item.dataset.angle) + 180);
          });
        });
        this.stage.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.turn(Number(this.visible[this.index].dataset.angle) + (event.key === 'ArrowRight' ? 180 : -180));
          }
        });
        this.stage.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          const item = event.target.closest('[data-item]');
          this.stopHover(false);
          const turning = item === this.visible[this.index] && item.dataset.hasBack === 'true';
          this.gesture = {x:event.clientX,y:event.clientY,item,turning,angle:Number(item?.dataset.angle || 0),moved:false,pointerId:event.pointerId};
          this.suppressClick = false;
        });
        this.stage.addEventListener('pointermove', event => {
          if (event.pointerType === 'mouse' && event.buttons === 0 && !this.gesture) {
            this.pendingHover = {x:event.clientX,y:event.clientY};
            if (!this.hoverFrame) this.hoverFrame = requestAnimationFrame(() => {
              this.hoverFrame = null;
              const point = this.pendingHover;
              this.pendingHover = null;
              if (point) this.hoverAt(point);
            });
            return;
          }
          const gesture = this.gesture;
          if (!gesture || !gesture.turning) return;
          const dx = event.clientX - gesture.x;
          const dy = event.clientY - gesture.y;
          if (!gesture.moved && (Math.abs(dx) < 8 || Math.abs(dx) <= Math.abs(dy))) return;
          if (!gesture.moved) {
            gesture.moved = true;
            this.stage.setPointerCapture(event.pointerId);
          }
          gesture.item.dataset.dragging = 'true';
          gesture.item.querySelector('[data-turntable]').style.setProperty('--turn', (gesture.angle + dx * 1.1) + 'deg');
        });
        this.stage.addEventListener('pointerup', event => {
          const gesture = this.gesture;
          if (!gesture) return;
          this.gesture = null;
          const dx = event.clientX - gesture.x;
          const dy = event.clientY - gesture.y;
          if (gesture.moved) {
            gesture.item.dataset.dragging = 'false';
            this.turn(Math.round((gesture.angle + dx * 1.1) / 180) * 180);
            this.suppressClick = true;
          } else if (!gesture.turning && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
            this.move(dx < 0 ? 1 : -1);
            this.suppressClick = true;
          }
          if (this.stage.hasPointerCapture(event.pointerId)) this.stage.releasePointerCapture(event.pointerId);
          setTimeout(() => { this.suppressClick = false; }, 200);
        });
        this.stage.addEventListener('pointerleave', () => { if (!this.gesture) this.stopHover(); });
        this.stage.addEventListener('pointercancel', () => {
          if (this.gesture?.item) {
            this.gesture.item.dataset.dragging = 'false';
            this.gesture.item.querySelector('[data-turntable]').style.setProperty('--turn', this.gesture.angle + 'deg');
          }
          this.gesture = null;
        });
        this.stage.addEventListener('dragstart', event => event.preventDefault());
        this.resize = new ResizeObserver(() => this.render());
        this.resize.observe(this.stage);
        this.render();
      }
      disconnectedCallback() { this.stopHover(false); this.resize?.disconnect(); }
      hoverAt(point) {
        const active = this.visible[this.index];
        if (!active || active.dataset.hasBack !== 'true') { this.stopHover(); return; }
        const bounds = active.getBoundingClientRect();
        if (point.x < bounds.left || point.x > bounds.right || point.y < bounds.top || point.y > bounds.bottom) {
          this.stopHover();
          return;
        }
        if (this.hover?.item !== active) {
          this.stopHover();
          this.hover = {item:active};
          active.dataset.hovering = 'true';
        }
        const position = (point.x - bounds.left) / bounds.width;
        const progress = Math.max(0,Math.min(1,(position - .3) / .4));
        const eased = progress * progress * (3 - 2 * progress);
        this.turn(eased * 180);
      }
      stopHover(snap = true) {
        if (this.hoverFrame) cancelAnimationFrame(this.hoverFrame);
        this.hoverFrame = null;
        this.pendingHover = null;
        const item = this.hover?.item;
        this.hover = null;
        if (!item) return;
        item.dataset.hovering = 'false';
        if (snap && item === this.visible[this.index]) this.turn(Math.round(Number(item.dataset.angle) / 180) * 180);
      }
      turn(angle) {
        const active = this.visible[this.index];
        if (active.dataset.hasBack !== 'true') return;
        active.dataset.angle = String(angle);
        active.querySelector('[data-turntable]').style.setProperty('--turn', angle + 'deg');
        this.updateView();
      }
      updateView() {
        const active = this.visible[this.index];
        const back = ((Math.round(Number(active.dataset.angle) / 180) % 2) + 2) % 2 === 1;
        active.dataset.view = back ? 'back' : 'front';
        this.querySelector('[data-turn-hint]').hidden = active.dataset.hasBack !== 'true';
        this.querySelector('[data-front-hint]').hidden = active.dataset.hasBack === 'true';
        active.querySelector('.dl-rack__face--front').setAttribute('aria-hidden', String(back));
        active.querySelector('.dl-rack__face--back').setAttribute('aria-hidden', String(!back));
      }
      move(direction) {
        this.stopHover();
        this.index = (this.index + direction + this.visible.length) % this.visible.length;
        this.render();
      }
      render() {
        const width = this.stage.clientWidth;
        const step = width < 750 ? 150 : Math.min(235,width * .19);
        this.items.forEach(item => {
          const position = this.visible.indexOf(item);
          item.hidden = position < 0;
          if (position < 0) return;
          let distance = position - this.index;
          if (distance > this.visible.length / 2) distance -= this.visible.length;
          if (distance < -this.visible.length / 2) distance += this.visible.length;
          const active = distance === 0;
          const angle = active ? 0 : (distance > 0 ? -62 : 62);
          item.style.transform = 'translateX(' + (distance * step) + 'px) translateZ(' + (-Math.abs(distance) * 75) + 'px) rotateY(' + angle + 'deg) scale(' + (active ? 1 : .88) + ')';
          item.style.zIndex = String(20 - Math.abs(distance));
          item.style.opacity = Math.abs(distance) > 3 ? '0' : String(Math.max(.4,1 - Math.abs(distance) * .13));
          item.style.pointerEvents = Math.abs(distance) > 3 ? 'none' : '';
          item.dataset.active = String(active);
          item.tabIndex = active ? 0 : -1;
          item.setAttribute('aria-hidden', String(Math.abs(distance) > 3));
        });
        const active = this.visible[this.index];
        this.panels.forEach(panel => panel.hidden = panel.dataset.panel !== active.dataset.number);
        this.querySelector('[data-count]').textContent = String(this.index + 1).padStart(2,'0') + ' / ' + String(this.visible.length).padStart(2,'0');
        this.updateView();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
